export const resetFilter = (params: any) => {
  params.setState({
    industries: null,
    businessScenes: null,
    suitables: null,
    searchInput: null,
  });
};
